import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  FormControl,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import CPVLogo from "../../../assets/CPV-Auto-logo-Final.png";
import * as acts from "../../../redux/auth/actions";
import { useDispatch } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import "./otpVal.scss";

export default function OtpModal({
  isOpenOtpModal,
  handleCloseOtpModal,
  userName,
  message,
  inValidUserErrorMessage,
}) {
  const [otp, setOtp] = useState("");
  const dispatch = useDispatch();

  const handleSubmit = () => {
    dispatch(acts.submitOtp(parseInt(otp)));
  };

  const handleResendOTP = () => {
    setOtp("");
    dispatch(acts.resendOtp(userName));
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit();
    }
  };
  return (
    <div>
      <Dialog
        className="otp-form-container-root"
        open={isOpenOtpModal}
        onClose={handleCloseOtpModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box component="main" className="otp-form-container-box ">
          <Grid container>
            <Grid item>
              <IconButton
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
                onClick={handleCloseOtpModal}
              >
                <CloseIcon />
              </IconButton>
              <div className="otp-form-image">
                <img src={CPVLogo} alt="Logo" />
              </div>

              <form>
                <Typography className="otp-form-typrogaphy">
                  {message}
                </Typography>
                <div className="otp-form-container">
                  <FormControl fullWidth className="otp-form">
                    <TextField
                      type="password"
                      variant="outlined"
                      placeholder="XXXXXX"
                      className={`otp-form-textfield`}
                      value={otp}
                      onChange={(event) => setOtp(event.target.value)}
                      onKeyDown={handleKeyPress}
                      inputProps={{
                        maxLength: 6,
                        style: {
                          textAlign: "center",
                          fontSize: "1rem",
                          padding: "9px 14px",
                        },
                      }}
                    />
                  </FormControl>
                </div>
                <div className="btn-submit-div">
                  <Button variant="outlined" onClick={handleSubmit}>
                    Submit
                  </Button>
                </div>
                {inValidUserErrorMessage && (
                  <label className="invalid-message-label">
                    *{inValidUserErrorMessage}
                  </label>
                )}
                <div className="btn-resend-dic">
                  <Button onClick={handleResendOTP}>Resend</Button>
                </div>
              </form>
            </Grid>
          </Grid>
        </Box>
      </Dialog>
    </div>
  );
}
